import React from 'react';

interface DataContext {
  additionalData: {
    allFaqItems: Queries.node__faq[];
  };
}

export default function Faq({additionalData}: DataContext): React.JSX.Element {
  return (
    <section className="vl-region">
      <div className="vl-layout">
        <div className="vl-grid vl-grid--is-stacked">
          <div className="vl-col--12-12 vl-col--12-12--m vl-col--12-12--s">
            <ul className="vl-accordion-list vl-accordion-list--bordered">
              {additionalData.allFaqItems.map(function (faqNode: Queries.node__faq, idx: number) {
                return (
                  <li key={idx} className="vl-accordion-list__item">
                    <div data-vl-accordion="" className="vl-accordion">
                      <button
                        className="vl-toggle vl-toggle--icon-right vl-link vl-link--bold"
                        data-vl-accordion-toggle=""
                      >
                        <i
                          className="vl-accordion__icon vl-link__icon vl-link__icon--before vl-toggle__icon vl-vi vl-vi-arrow-right-fat"
                          aria-hidden="true"
                        ></i>
                        <span className="vl-accordion__title">
                          {faqNode.title}
                        </span>
                      </button>
                      <div className="vl-accordion__content js-vl-accordion__content">
                        <div
                          className="vl-accordion__panel vl-accordion__panel--no-indent"
                          dangerouslySetInnerHTML={{
                            __html: faqNode.body?.processed,
                          }}
                        />
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
